import React, { useMemo } from "react";
import Wrapper from "components/commons/wrapper/Wrapper";
import Header from "components/commons/header/Header";
import { strings } from "intl/fa";
import { useAppSelector } from "utils/store";
import { TutorialPages } from "core/tutorials/tutorials.slice";
import TutorialsList from "./TutorialsList";
import ArticlesPage from "./articles/ArticlesPage";
import VideosPage from "./videos/VideosPage";
import TutorialsBreadcrumb from "./TutorialsBreadcrumb";

const TutorialsWrapper: React.FC<React.PropsWithChildren<unknown>> = () => {
  const page = useAppSelector((state) => state.tutorials.page);

  const CurrentPage = useMemo(() => {
    switch (page) {
      case TutorialPages.AllTutorials:
        return <TutorialsList />;
      case TutorialPages.TutorialArticles:
        return <ArticlesPage />;
      case TutorialPages.TutorialVideos:
        return <VideosPage />;
    }
  }, [page]);

  return (
    <Wrapper>
      <Header title={strings.tutorials.title} />
      <TutorialsBreadcrumb />
      {CurrentPage}
    </Wrapper>
  );
};

export default TutorialsWrapper;
